import React, { useState, useMemo, useEffect } from 'react'
import Navigation from '../Navigation'
import { Row, Container } from 'react-bootstrap'
import { Truck } from 'react-bootstrap-icons'
import './DocumentDetailIvend.css'
import { t } from 'i18next'
import MiniLoading from 'Components/MiniLoading'
import { DocumentAddressDetails } from './components/DocumentAddressDetails'
import ProductsTable from './components/ProductsTable'
import { ListPaymentTypes } from './components/ListPaymentType'
import { formatedDate, FormatMoney } from 'Utils/functions'
import RelationDocs from './components/RelationDocs/RelationDocs'
import { CustomTooltip } from 'Components/CustomToolTip'
import OrderTrackingModal from 'Components/OrderTrackingModal/OrderTrackingModal'
import {
  fullfilmentIds,
  getTrackingRestrictedCompanyIds,
} from 'Utils/constants'
import { useSelector } from 'react-redux'

// IDs de compañías que tienen restricción de tracking
const TRACKING_RESTRICTED_COMPANY_IDS = getTrackingRestrictedCompanyIds()

function DocumentDetailIvend({
  data,
  loadingData,
  combinedArray,
  columns,
  title,
  isInvoice,
}) {
  const companyId = useSelector(state => state.company.CompanyId)

  const [productTable, setProductTable] = useState([])
  const [realtionDocs, setRealtionDocs] = useState([])
  const [showTrackingModal, setShowTrackingModal] = useState(false)

  const isValidData = data && Object.keys(data).length > 0

  const fulfillmentPlan = isInvoice && data?.Lines?.[0]?.FulfillmentPlan?.Name

  const invoiceCanShowTracking =
    fulfillmentPlan === fullfilmentIds.homeDelivery.fulfillmentPlanDescription

  // Verificar si la compañía actual tiene acceso al tracking
  const hasTrackingAccess = useMemo(
    () => !TRACKING_RESTRICTED_COMPANY_IDS.includes(companyId),
    [companyId]
  )

  const shouldShowTrackingButton = hasTrackingAccess && invoiceCanShowTracking

  const setTableData = products => {
    if (!products) return []
    const productsArray = products?.map((product, index) => {
      return {
        referencia: product?.SKU,
        descripción: product?.ProductName,
        cantidad: product?.Quantity,
        precio_unitario: FormatMoney(product?.UnitPrice, true, 4),
        descuento: FormatMoney(product?.AmontDiscount, true, 2),
        precio_total: FormatMoney(product?.Total, true, 2),
        plan_entrega: product?.FulfillmentPlan?.Name,
      }
    })
    return productsArray
  }

  const productsData = useMemo(() => {
    if (isValidData) {
      return setTableData(data?.Lines)
    }
  }, [data])

  useEffect(() => {
    if (isValidData) {
      setProductTable(productsData)

      setRealtionDocs(combinedArray)
    }
  }, [data])

  useEffect(() => {}, [productTable])

  return (
    <>
      <Navigation />
      {loadingData ? (
        <MiniLoading full={true} noMargin={true} />
      ) : (
        <>
          <div className="documents-detail-container">
            <div className="documents-detail" style={{ paddingBottom: '16px' }}>
              <div className="documents-detail-header">
                <h2 className="documents-detail-title">{t(title)}</h2>
                {shouldShowTrackingButton && (
                  <div className="order-tracking-container">
                    <CustomTooltip
                      placement="bottom-end"
                      title={
                        <p style={{ fontSize: 12 }}>Trazabilidad de pedidos</p>
                      }>
                      <button
                        className="order-tracking-btn"
                        onClick={() => setShowTrackingModal(true)}>
                        <div className="left">
                          <p>nuevo</p>
                        </div>
                        <div className="right">
                          <Truck className="order-tracking-icon" />
                          {t('DISPATCH_ORDER_T.ORDER_TRACKING')}
                        </div>
                      </button>
                    </CustomTooltip>
                  </div>
                )}
              </div>
              <div className="documents-detail-info-gen">
                <div className="documents-detail-info-gen-customer">
                  <p className="documents-detail-info-gen-text">
                    {t('DETAIL_DOCUMENTS_T.CUSTOMER_LABEL', {
                      customer:
                        data?.Customer?.FullName ||
                        t('DETAIL_DOCUMENTS_T.NO_INFO_LABEL'),
                    })}
                  </p>
                  <p className="documents-detail-info-gen-text">
                    {t('DETAIL_DOCUMENTS_T.EMAIL_LABEL', {
                      email:
                        data?.Customer?.Email ||
                        t('DETAIL_DOCUMENTS_T.NO_INFO_LABEL'),
                    })}
                  </p>
                  <p className="documents-detail-info-gen-text">
                    {t('DETAIL_DOCUMENTS_T.PHONE_LABEL', {
                      phone:
                        data?.Customer?.Phone ||
                        t('DETAIL_DOCUMENTS_T.NO_INFO_LABEL'),
                    })}
                  </p>
                  <p
                    className="documents-detail-info-gen-text"
                    style={{ display: 'flex' }}>
                    {t('DETAIL_DOCUMENTS_T.PAYMENT_METHOD')}
                    <div style={{ marginLeft: 5 }}>
                      {data?.PaymentMethods?.length && (
                        <ListPaymentTypes
                          payments={data?.PaymentMethods}
                          creditNumber={data?.Customer?.CreditAccountNumber}
                        />
                      )}
                    </div>
                  </p>
                </div>
                {isInvoice && <DocumentAddressDetails details={data} />}

                <div className="documents-detail-info-gen-sales-person">
                  <p className="documents-detail-info-gen-text">
                    {isInvoice
                      ? t('DETAIL_DOCUMENTS_T.INVOICE_ID', {
                          invoiceId: data?.IntegrationDocumentId?.toUpperCase(),
                        })
                      : t('DETAIL_DOCUMENTS_T.REPAYMENT_ID', {
                          repaymentId:
                            data?.IntegrationDocumentId?.toUpperCase(),
                        })}
                  </p>
                  <p className="documents-detail-info-gen-text">
                    {t('DETAIL_DOCUMENTS_T.SALES_PERSON', {
                      salesPerson: data?.SalesPerson?.FullName,
                    })}
                  </p>
                  <p className="documents-detail-info-gen-text">
                    {t('DETAIL_DOCUMENTS_T.WAREHOUSENAME', {
                      warehouse: data?.Warehouse?.WarehouseName,
                    })}
                  </p>
                  <p className="documents-detail-info-gen-text">
                    {formatedDate(data?.IssueDate)}
                  </p>
                </div>
              </div>

              <ProductsTable
                data={productTable}
                columns={columns}
                hideFooter={true}
                isProductPage={false}
                totals={data?.Total}
              />
            </div>

            <Container className="footer-container">
              <div className="footer-info">
                <div style={{ width: '25%' }}>
                  <Row className="footer-left-text-title">
                    {t('DETAIL_DOCUMENTS_T.RELATED_DOCS')}
                  </Row>
                  {realtionDocs?.map((item, index) => (
                    <Row className="footer-left-text" key={index}>
                      <RelationDocs value={item} document={realtionDocs} />
                    </Row>
                  ))}
                </div>
                <div>
                  {data?.DeliverySetting?.BeetrackHistory?.length ? (
                    <Row className="footer-left-text-title">
                      {t('DETAIL_DOCUMENTS_T.TRACKING_NUMBER')}
                    </Row>
                  ) : null}

                  <div
                    style={{
                      alignItems: 'center',
                      marginTop: 5,
                      marginBottom: 15,
                      gap: 15,
                    }}>
                    {data?.DeliverySetting?.BeetrackHistory?.map(beetrack => (
                      <>
                        {beetrack.BeeCode}
                        <button
                          className="documents-detail-button"
                          onClick={() => {
                            const url = beetrack.TrackingUrl
                            if (url)
                              window.open(url, '_blank', 'noopener,noreferrer')
                          }}>
                          {t('DETAIL_DOCUMENTS_T.POOF_DELIVERY')}
                        </button>
                      </>
                    ))}
                  </div>
                  {data?.BackupDocs?.length ? (
                    <Row className="footer-left-text-title">
                      {t('DETAIL_DOCUMENTS_T.SUPPORTING_DOCUMENTS')}
                    </Row>
                  ) : null}

                  <div style={{ display: 'flex' }}>
                    <div
                      style={{ alignItems: 'center', marginTop: 5, gap: 15 }}>
                      {data?.BackupDocs?.map((image, index) => (
                        <>
                          <div style={{ display: 'flex' }}>
                            <div key={index} className="image-container">
                              <img
                                src={image?.BlobUrl}
                                alt="Miniatura"
                                className="image-supporting-documents"
                              />
                              {image?.DocType}
                            </div>
                          </div>
                        </>
                      ))}
                    </div>
                    <div
                      style={{
                        alignItems: 'center',
                        marginTop: 5,
                        gap: 15,
                        display: 'flex',
                        flexDirection: 'column',
                      }}>
                      {data?.BackupDocs?.map((image, index) => (
                        <>
                          <button
                            className="documents-detail-button"
                            onClick={() => {
                              const newTab = window.open()
                              if (newTab) {
                                newTab.document.write(
                                  `<html><head><title>Imagen</title></head><body style="margin:0;display:flex;justify-content:center;align-items:center;height:100vh;background-color:#000;">
              <img src="${image?.BlobUrl}" style="max-width:100%;max-height:100%;" />
            </body></html>`
                                )
                                newTab.document.close()
                              }
                            }}>
                            {t('DETAIL_DOCUMENTS_T.DIGITIZATION_IMAGE')}
                          </button>
                        </>
                      ))}
                    </div>
                  </div>
                </div>
                <div>
                  <Row className="footer-right-text-title">
                    {t('DETAIL_DOCUMENTS_T.COMMENT')}
                  </Row>

                  <textarea
                    className="footer-textarea-style"
                    value={data?.DeliverySetting?.DeliveryNote || ''}
                  />
                </div>
              </div>
            </Container>
          </div>
        </>
      )}
      <OrderTrackingModal
        open={showTrackingModal}
        onClose={() => setShowTrackingModal(false)}
        companyID={data?.Company?.CompanyId}
        invoiceNumber={data?.DocumentNumber}
      />
    </>
  )
}

export default DocumentDetailIvend
